import { useEffect, useState } from "react"
import { FormProvider, useForm } from "react-hook-form"
import { FormSelectionBox } from "../Components/InputBox"
import { ConditionFilterFrame, H2HEmptyFrame, H2HKZoneFrame, H2HPLocFrame, H2HTableFrame } from "../Components/HeadToHeadFrames"
import { api_getPlayerGameReportData, api_getPlayerHeadtoHeadData, api_getPlayerRoster } from "../API/axios"
import { extractHeadToHeadData, resolvePlayerIDMap } from "../Utils/HeadToHeadUtils"
import Header from "../Components/Header"
import Footer from "../Components/Footer"
import Loading from "../Components/Loading"
import { GRPlayByPlayFrame, GameReportPAFrame, GameReportPLocFrame } from "../Components/GameReportContent"
import { wrapPBPData } from "../Utils/GameReportUtils"
import { EmptyFrame } from "../Components/PersonFrame"
import { useParams } from "react-router"

const Tabs = ({tags, current, setCurrent}) => {
  let tabs = []
  for (const e in tags) {
    let tab_classname = e === current ? 'tabr' : 'tab'
    let arrow_classname = e === current ? 'tab_arrowr' : 'tab_arrow'
    tabs.push(
      <div className='tab_block' id={e} onClick={(e) => { setCurrent(e.target.id) }}>
        <div className={tab_classname} id={e}>{tags[e]}</div>
        <div className={arrow_classname} />
      </div>
    )
  }
  return tabs
}

const SingleGameReport = () => {
  const [current, setCurrent] = useState('h2h-data')
  const [data, setData] = useState({discipline: [], kzone: [], location: {all: [], hit: []}, stat: [], rawdata: []})
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const [player, setPlayer] = useState("")
  const [date, setDate] = useState(null)
  const { year, game, playerid, type } = useParams()

  useEffect(() => {
    setLoading(true)
    let wrapped = {}
    wrapped[type==='pitcher'?'Pitcherid':'Batterid'] = playerid
    wrapped['Year'] = year
    wrapped['GameNo'] = game
    // console.log(wrapped)
    api_getPlayerGameReportData(wrapped).then((res) => {
      // console.log(extractHeadToHeadData(res.data))
      setData({...extractHeadToHeadData(res.data), rawdata: res.data})
      setPlayer(res.data[0][type==='pitcher'?"Pitcher":"Batter"])
      setDate(res.data[0].Date)
      setLoading(false)
      setError(false)
    })
  }, [])

  const GameReportContent = ({mode, data}) => {
    if (mode==='h2h-data') {
      return (
        <>
          <GameReportPAFrame data={data.rawdata} type={type} />
          <H2HTableFrame discipline={data.discipline} stat={data.stat} />
          <GameReportPLocFrame data={data.location} type={type} />
        </>
      )
    } else if (mode==='play-by-play') {
      return (
        <>
          {
            data.rawdata.length > 0?
            <GRPlayByPlayFrame data={wrapPBPData(data.rawdata)} type={type} />:
            <EmptyFrame message="查無相關資料" />
          }
        </>
      )
    }
  }

  return (
    <>
      <Loading visible={loading} />
      <Header />
      <div className="wrapper">
        <div className="wrap setin">
          <div className="person_score">
            <div className="title_frame">
            <div className="report-title">
                <div className="report-entry">{date}</div>
                <div className="report-entry">Game {game}</div>
                <div className="report-entry">{player}</div>
              </div>
              <div className="title">單場表現報告</div>
            </div>
          </div>
        </div>
      </div>
      <div className="wrapper pp_bg_gray">
        <div className='wrap setin'>
          <div className='lb_page_tab_frame'>
            <Tabs tags={{'h2h-data': '投手配球分析', 'play-by-play': '逐打席逐球內容'}} current={current} setCurrent={setCurrent} />
          </div>
          <div className='page'>
            <div className="page_content tab_table">
              {
                (data.discipline.length === 0 || error)? <H2HEmptyFrame error={error} /> : 
                <GameReportContent mode={current} data={data} />
              }
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  )
}

export default SingleGameReport